/**
 * 上传相关
 */
import axios from "axios";
import https from "../../utils/http";
import { getToken, getAdminId } from "../../utils/auth";
let http = https.https;

// 获取七牛上传 upToken
export function qiuNiuUpToken(query) {
    let querys = {};
    if (query !== null && query !== undefined) {
        querys = JSON.parse(JSON.stringify(query));
    }
    querys.ADMIN_ID = getAdminId();
    querys.ADMIN_TOKEN = getToken();
    return axios({
        url: http + "/file/upload/qiuNiuUpToken",
        method: "get",
        params: querys
    });
}

// 上传文件
export function createFile(url, formdata) {
    let querys = formdata;
    querys.append("ADMIN_ID", getAdminId());
    querys.append("ADMIN_TOKEN", getToken());
    // querys. = getAdminId();
    // querys.ADMIN_TOKEN = getToken();
    return axios({
        url: url,
        method: "post",
        data: querys
    });
}
